// @ts-nocheck
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePlatformSettings } from '../hooks/usePlatformSettings';

const ROUTE_TITLES: Record<string, string> = {
  '/': 'داشبورد',
  '/sites': 'سایت‌ها',
  '/pages': 'صفحات',
  '/products': 'محصولات',
  '/blog': 'بلاگ',
  '/forms': 'فرم‌ها',
  '/gallery': 'گالری',
  '/testimonials': 'نظرات مشتریان',
  '/team': 'تیم',
  '/faq': 'سوالات متداول',
  '/projects': 'پروژه‌ها',
  '/settings': 'تنظیمات عمومی',
  '/theme': 'قالب و رنگ‌ها',
  '/navigation': 'مدیریت منوها',
  '/audit-log': 'فعالیت‌ها',
  '/profile': 'پروفایل',
  '/storage': 'فضای ذخیره‌سازی',
  '/analytics': 'آمار و تحلیل‌ها',
  '/seo': 'سئو',
  '/admin': 'سوپر ادمین',
  '/admin/users': 'مدیریت کاربران',
  '/admin/system-settings': 'تنظیمات سیستم',
  '/admin/plans': 'پلن‌ها',
  '/admin/module-limits': 'محدودیت‌های ماژول‌ها',
};

export function DocumentHead() {
  const { currentSite, isSuperAdmin } = useAuth();
  const platformSettings = usePlatformSettings();
  const location = useLocation();

  useEffect(() => {
    // Set document title based on route
    const path = location.pathname;
    let title = ROUTE_TITLES[path] || 'پنل مدیریت';
    if (currentSite) {
      title = `${title} - ${currentSite.name}`;
    } else {
      title = `${title} - ${platformSettings.platform_name}`;
    }
    document.title = title;
  }, [currentSite, location, platformSettings.platform_name]);

  useEffect(() => {
    // Set favicon - always use platform favicon in admin panel
    const faviconUrl = platformSettings.platform_favicon_url;

    // Remove existing favicons
    const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    existingFavicons.forEach(el => el.remove());

    // Add new favicon with multiple formats for better browser support
    if (faviconUrl) {
      // PNG favicon
      const linkPng = document.createElement('link');
      linkPng.rel = 'icon';
      linkPng.type = 'image/png';
      linkPng.href = faviconUrl;
      document.head.appendChild(linkPng);

      // ICO fallback (same URL, browsers will handle it)
      const linkIco = document.createElement('link');
      linkIco.rel = 'shortcut icon';
      linkIco.href = faviconUrl;
      document.head.appendChild(linkIco);
    }
  }, [platformSettings.platform_favicon_url]);

  return null;
}
